import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_c61eb3a6-eca5-4227-9115-b8ca96405a47/artifacts/zd13mtbj_F429A9FE-5AF6-4B77-9FE8-06E1627EDB41.PNG";

export default function Header() {
  const { lang, toggle, t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  const navItems = [
    { id: "work", label: t.nav.work },
    { id: "services", label: t.nav.services },
    { id: "collective", label: t.nav.collective },
    { id: "process", label: t.nav.process },
    { id: "book", label: t.nav.book },
    { id: "contact", label: t.nav.contact },
  ];

  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
          <img src={LOGO_URL} alt="Salside.Production" className="h-10 w-10 object-contain" />
          <span className="hidden sm:block font-mono-tight text-zinc-300">Salside.Production</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="primary-nav">
          {navItems.map((it) => (
            <button
              key={it.id}
              onClick={() => goTo(it.id)}
              data-testid={`nav-${it.id}-btn`}
              className="font-mono-tight text-zinc-400 hover:text-white transition-colors"
            >
              {it.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-5">
          <button
            onClick={toggle}
            data-testid="lang-toggle-btn"
            className="font-mono-tight"
            aria-label="Toggle language"
          >
            <span className={lang === "fr" ? "text-white" : "text-zinc-600"}>FR</span>
            <span className="text-zinc-700 mx-1">/</span>
            <span className={lang === "en" ? "text-white" : "text-zinc-600"}>EN</span>
          </button>
          <button
            className="md:hidden text-white"
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-btn"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {navItems.map((it) => (
              <button
                key={it.id}
                onClick={() => goTo(it.id)}
                data-testid={`mobile-nav-${it.id}-btn`}
                className="font-mono-tight text-zinc-300 hover:text-white text-left"
              >
                {it.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
